module.exports = __webpack_public_path__ + "img/envelope.a5271909.svg";